const styles = theme => ({
  content: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    maxWidth: '800px',
    maxHeight: '800px',
    overflowY: 'auto',
    '@media (max-width: 768px)': {
      maxHeight: '600px',
      overflowY: 'auto',
    },
    '@media (max-width: 480px)': {
      maxHeight: '400px',
      padding: '0 10px',
    },
    '@media (max-height: 768px)': {
      maxHeight: '500px',
      overflowY: 'auto',
    },
    '@media (max-height: 480px)': {
      maxHeight: '300px',
      padding: '0 10px',
    },
  },
  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  title: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  note: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  badgeLeft: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    background: 'var(--mcg-bg, #E3F3FF)',
  },
  badgeRight: {
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '50px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  description: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  dividerContainer: {
    width: '100%',
  },
  divider: {
    height: '1px',
    background: '#E5E7EB',
  },
  educationalText: {
    color: '#4B5563',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '150%' /* 21px */,
    marginRight: '4px',
  },
  educationalContainer: {
    display: 'flex',
  },
  headerSelect: {
    color: 'var(--mcg-dark, #002E47)',
    /* Button/Large */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
  selectContainer: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--12, 12px)',
    alignSelf: 'stretch',
    borderRadius: '12px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
  },
  badgeContainer: {
    display: 'flex',
    gap: '12px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2, 0),
  },
  textSection: {
    flex: 1,
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1), // Creates space between buttons
  },
})

export default styles
